module.exports = __webpack_public_path__ + "img/register-info.5aecf5b7.svg";